import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import PsychologicalMatrix from './components/PsychologicalMatrix';
import TechnologyFreedom from './components/TechnologyFreedom';
import MindsetMovement from './components/MindsetMovement';
import MatrixTest from './components/MatrixTest';
import FloatingChat from './components/FloatingChat';
import Mission from './components/Mission';
import Footer from './components/Footer';
import MatrixBackground from './components/MatrixBackground';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-darker text-light-gray relative overflow-hidden">
        <MatrixBackground />
        <Header />
        <FloatingChat />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <PsychologicalMatrix />
                <TechnologyFreedom />
                <MindsetMovement />
                <MatrixTest />
                <Mission />
              </>
            } />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
